module.exports = __webpack_public_path__ + "img/kcjs-title.27169874.png";